import {
  call,
  getContext,
  put,
  takeEvery,
  takeLatest,
} from "redux-saga/effects";

import { CONTEXT } from "@const/redux";
import {
  addCardActionTypes,
  deleteCardActionTypes,
  getCardsActionTypes,
} from "./actionTypes";
import {
  addCardFailure,
  addCardSuccess,
  deleteCardFailure,
  deleteCardSuccess,
  getCardsFailure,
  getCardsSuccess,
} from "./actions";
import ToastService from "../../services/ToastService";
import { normalizeCardArray } from "@helpers/cards";

const addCardAsync = ({ CardsService, ...body }) => {
  if (!CardsService) {
    console.log("Required service is missing");
    return;
  }

  return CardsService.addCard(body);
};

export const setDefaultCardAsync = ({ CardsService, id }) => {
  return CardsService.setDefaultCard(id);
};

function* addCard({ payload }) {
  try {
    const { CardsService } = yield getContext(CONTEXT.SERVICES);

    const { data } = yield call(addCardAsync, { CardsService, ...payload });
    yield call(setDefaultCardAsync, {
      CardsService,
      id: data.id,
    });

    yield put(addCardSuccess({ ...data, isDefault: true }));
  } catch ({ error }) {
    yield put(addCardFailure());
    ToastService.error(error?.message);
  }
}

const getCardsAsync = ({ CardsService }) => {
  if (!CardsService) {
    console.log("Required service is missing");
    return;
  }

  return CardsService.getCards();
};

export function* getCards() {
  try {
    const { CardsService } = yield getContext(CONTEXT.SERVICES);

    const { data } = yield call(getCardsAsync, { CardsService });

    const {
      result,
      entities: { cards },
    } = normalizeCardArray(data);

    yield put(getCardsSuccess({ result, cards }));
  } catch ({ error }) {
    yield put(getCardsFailure());
    ToastService.error(error?.message);
  }
}

const deleteCardAsync = ({ CardsService, id }) => {
  if (!CardsService) {
    console.log("Required service is missing");
    return;
  }

  return CardsService.deleteCard(id);
};

function* deleteCard({ payload }) {
  const { id } = payload;

  try {
    const { CardsService } = yield getContext(CONTEXT.SERVICES);

    yield call(deleteCardAsync, { CardsService, id });

    yield put(deleteCardSuccess({ id }));
  } catch ({ error }) {
    yield put(deleteCardFailure({ id }));
  }
}

export function* watchAddCard() {
  yield takeEvery(addCardActionTypes.request, addCard);
}

export function* watchGetCards() {
  yield takeLatest(getCardsActionTypes.request, getCards);
}

export function* watchDeleteCard() {
  yield takeEvery(deleteCardActionTypes.request, deleteCard);
}
